import './Toast.css'
import cx from 'classnames'
import { ReactNode } from 'react'
import { CheckCircleIcon } from '../icons'
import TriangleExclamation from '../icons/TriangleExlamation/TriangleExclamation'

type ToastType = 'success' | 'error' | 'blank' | 'custom' | 'warning' | 'loading'

const toastTypeToIcon: Record<string, ReactNode | null> = {
  success: <CheckCircleIcon className="toast-icon-success" />,
  error: <TriangleExclamation className="toast-icon-error" />,
  warning: <TriangleExclamation className="toast-icon-warning" />
}

const toastTypeToBorderClass: Record<string, string> = {
  success: 'toast-success',
  error: 'toast-error',
  blank: 'toast-blank',
  custom: 'toast-custom',
  warning: 'toast-warning'
}

export function Toast({ message, type }: { message: ReactNode; type: ToastType }) {
  const icon = toastTypeToIcon[type]
  const borderClass = toastTypeToBorderClass[type]
  return (
    <div className={cx('toast-base', borderClass)}>
      <div className="toast-content">
        <div className="toast-icon">{icon}</div>
        <span className="toast-message">{message}</span>
      </div>
    </div>
  )
}
